.container {
  flex: 1;
  width: 90%;
  max-width: 90%;
  min-width: 90%;
  scroll-snap-align: start;
  background-color: var(--color-surface-primary);

  @media (min-width: 768px) {
    width: 32rem;
    min-width: 32rem;
    max-width: 32rem;
  }
}

.header {
  margin-bottom: 1.2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
}
